import React from "react";
import Zoom from "react-medium-image-zoom";

import "react-medium-image-zoom/dist/styles.css";

interface Props {
  src: string;
  alt: string;
  className?: string;
}

/** Image that opens enlarged in an overlay when clicked. */
export const ZoomImage = ({ src, alt, className }: Props) => (
  <Zoom>
    <img className={className} src={src} alt={alt} />
  </Zoom>
);
